// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"38":"c8125e7ee5cfe28d","562":"d5030892f03a735e","600":"837a7bcc3dbd3003","719":"8e0fa681191e8a57","943":"6107304763cf2fa5"}[chunkId] + ".js";
};